"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParentApplicantRelationshipType = exports.StatedOwnership = exports.CitizenshipResidencyType = exports.StatedUrgencyType = exports.StatedUsageAmountKind = exports.StatedUsageType = exports.VestingOwnerType = exports.MaritalStatus = exports.ApplicantType = exports.APPLICANT_MAX_AGE_YEARS = exports.APPLICANT_MIN_AGE_YEARS = void 0;
/** Minimum age (years) an applicant must be to originate (age of majority). */
exports.APPLICANT_MIN_AGE_YEARS = 18;
/**
 * Maximum plausible applicant age (years). Anything older is treated as a sentinel /
 * data-entry error (e.g. the 1800-01-01 placeholder a partner once sent, which passed
 * format validation, propagated through origination, and was rejected downstream by
 * SentiLink as "The provided dob is invalid"). Expressed as an age rather than a fixed
 * birth year so genuine centenarians are accepted: the oldest verified human lived to
 * 122, so 125 leaves headroom without accepting implausible ages.
 */
exports.APPLICANT_MAX_AGE_YEARS = 125;
/** @TranslateToPython @TranslateToEnum @TranslateToRust */
var ApplicantType;
(function (ApplicantType) {
    /** i.e. regular applicant */
    ApplicantType["primary"] = "primary";
    /** is underwritten along with primary */
    ApplicantType["coApplicant"] = "coApplicant";
    /** purely for signature purposes */
    ApplicantType["coOwner"] = "coOwner";
    /** purely for signature purposes */
    ApplicantType["livingTrustMember"] = "livingTrustMember";
    /** purely for signature purposes */
    ApplicantType["llcMember"] = "llcMember";
})(ApplicantType || (exports.ApplicantType = ApplicantType = {}));
/** @TranslateToPython */
var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus["MARRIED"] = "MARRIED";
    MaritalStatus["UNMARRIED"] = "UNMARRIED";
    MaritalStatus["SEPARATED"] = "SEPARATED";
})(MaritalStatus || (exports.MaritalStatus = MaritalStatus = {}));
// These are not 1-1 mappings of real vesting owner types
// These are the 'categories' of vesting owner types we care about
// Generally speaking: was the owner of this property married at the time of purchase?
var VestingOwnerType;
(function (VestingOwnerType) {
    VestingOwnerType["IS_MARRIED"] = "IS_MARRIED";
    VestingOwnerType["OTHER"] = "OTHER";
})(VestingOwnerType || (exports.VestingOwnerType = VestingOwnerType = {}));
/** @TranslateToPython @TranslateToRust */
// Mirrored in aven_backend and aven_python
var StatedUsageType;
(function (StatedUsageType) {
    StatedUsageType["HOME_IMPROVEMENT"] = "Home Improvement";
    StatedUsageType["BALANCE_TRANSFER"] = "Balance Transfer";
    // First-lien purchase: the applicant is buying a home rather than drawing against one they own.
    // The accompanying statedUsageAmount carries the max home price they are shopping for.
    StatedUsageType["HOME_PURCHASE"] = "Home Purchase";
    StatedUsageType["OTHER"] = "Other";
})(StatedUsageType || (exports.StatedUsageType = StatedUsageType = {}));
/**
 * How to read the loan application's statedUsageAmount. A null kind means policyDefined.
 * @TranslateToPython
 */
var StatedUsageAmountKind;
(function (StatedUsageAmountKind) {
    // Each underwriting policy decides: net cash, cash plus payoffs, or a line size bonus.
    StatedUsageAmountKind["policyDefined"] = "policyDefined";
    // The amount is the line size the applicant selected. Python starts from it verbatim for every policy.
    StatedUsageAmountKind["lineSize"] = "lineSize";
})(StatedUsageAmountKind || (exports.StatedUsageAmountKind = StatedUsageAmountKind = {}));
var StatedUrgencyType;
(function (StatedUrgencyType) {
    StatedUrgencyType["WEEK"] = "Week";
    StatedUrgencyType["MONTH"] = "Month";
    StatedUrgencyType["YEAR"] = "Year";
})(StatedUrgencyType || (exports.StatedUrgencyType = StatedUrgencyType = {}));
var CitizenshipResidencyType;
(function (CitizenshipResidencyType) {
    CitizenshipResidencyType["CITIZEN"] = "CITIZEN";
    CitizenshipResidencyType["NON_PERMANENT_RESIDENT_ALIEN"] = "NON_PERMANENT_RESIDENT_ALIEN";
    CitizenshipResidencyType["PERMANENT_RESIDENT_ALIEN"] = "PERMANENT_RESIDENT_ALIEN";
})(CitizenshipResidencyType || (exports.CitizenshipResidencyType = CitizenshipResidencyType = {}));
var StatedOwnership;
(function (StatedOwnership) {
    StatedOwnership["RENT"] = "RENT";
    StatedOwnership["OWN"] = "OWN";
})(StatedOwnership || (exports.StatedOwnership = StatedOwnership = {}));
// A secondary's relationship to the primary. Meaning is row-type dependent:
//  • coOwner — the MARRIED vs MARRIED_COOWNER split also encodes on-title-ness
//  • coApplicant — MARRIED just means married-to-primary; title is checked by the owner-name-match engine
//  • null ≠ OTHER — null is "never attested", OTHER is "attested NOT a spouse"
// Most readers treat both married values as one "is a spouse" set; the few that distinguish them are reading the
// on-title bit and are coOwner-only by construction. Never key on MARRIED alone without filtering applicant type.
/** @TranslateToPython */
var ParentApplicantRelationshipType;
(function (ParentApplicantRelationshipType) {
    ParentApplicantRelationshipType["MARRIED"] = "married";
    ParentApplicantRelationshipType["MARRIED_COOWNER"] = "married_coowner";
    ParentApplicantRelationshipType["OTHER"] = "other";
})(ParentApplicantRelationshipType || (exports.ParentApplicantRelationshipType = ParentApplicantRelationshipType = {}));
